$(document).ready(function () {

  //$('.view-more-btn').addClass('d-none');

  $('.modal .modal-footer .app-btn').hide();

  $(window).scroll(function () {
    setGoUp($(document).scrollTop());

    if ($(window).scrollTop() + window.innerHeight === $(document).height()) {
      if ($(window).scrollTop() > 300) {
        //$('.my-go-up').fadeOut();
        $('.my-go-up').css({"margin-bottom": "100px"});
        $('.my-go-up').fadeIn();
        //$('.my-go-prev').fadeOut();
        $('.my-go-prev').css({"margin-bottom": "100px"});
        $('.my-go-prev').fadeIn();
      }
    } else {
      if ($(window).scrollTop() > 300) {
        $('.my-go-up').css({"margin-bottom": "0px"});
        $('.my-go-prev').css({"margin-bottom": "0px"});
      }
    }

  });

  $('.my-go-prev').click(function (e) {
    e.preventDefault();
    go_Back(1);
  });

  $('.my-go-up').click(function (e) {
    e.preventDefault();
    pageSlide($('#wrapper'), {scrool_speed: 750, paddingTop: 0});
  });

  function go_Back(times) {
    if (!isNaN(times) && times > 0) {
      history.back(times);
    } else {
      history.back(1);
    }
  }

  function pageSlide(slide2, scrool_config) {
    var scrool_speed = 0,
      scrool_depth = 0,
      scrool_padtop = (typeof scrool_config.paddingTop === 'undefined' || isNaN(scrool_config.paddingTop)) ? 0 : scrool_config.paddingTop;

    if (typeof slide2 !== 'undefined' && slide2.length > 0 && typeof scrool_config !== 'undefined' && scrool_config !== null) {
      scrool_speed = (typeof scrool_config.scrool_speed === 'undefined' || scrool_config.scrool_speed < 1 || isNaN(scrool_config.scrool_speed)) ? 1000 : scrool_config.scrool_speed;
      scrool_depth = (typeof scrool_config.scrool_depth === 'undefined' || scrool_config.scrool_depth < 1 || isNaN(scrool_config.scrool_depth)) ? slide2.offset().top : scrool_config.scrool_depth;

      $('html, body').animate({
        scrollTop: scrool_depth + scrool_padtop
      }, parseInt(scrool_speed));
    }
  }

  function setGoUp(scrollTop) {
    if (scrollTop > 300 && $('.my-go-up:hidden').length > 0) {
      $('.my-go-up').fadeIn('slow');
      $('.my-go-prev').fadeIn('slow');
    } else if (scrollTop <= 300 && $('.my-go-up:visible').length > 0) {
      $('.my-go-up').fadeOut('slow');
      $('.my-go-prev').fadeOut('slow');
    }
  }


/*
  let counter = 6;
  const ownUrl = new URL(window.location.href);
  const fullUrl = `${ownUrl.origin}/api${ownUrl.pathname}`;
  let nameOrderBy = '{"created_at":"desc","starts_at": "desc"}';

  $('.view-more-btn').on('click', function () {
    fetch(fullUrl + `?order=${nameOrderBy}&pageSize=12&page=1&filter={"where": {"column":"status","operator":"=","value":"publish"}}`)
      .then(product => product.json())
      .then(function (data) {

        counter = 4;

        if (data.model != undefined && Object.keys(data.model).length > 0) {
          if (data.model.Articles != undefined && Object.keys(data.model.Articles).length > 0) {
            let articles = data.model.Articles;

            for (let i = 0; i < articles.length; i++) {
              if (i <= 7) {
                $(".contacts #content-products").append(bindOneCardProduct(articles[i]));
              } else {
                $(".contacts #content-products").append(bindOneCardProduct(articles[i]));
              }
            }
          }

          if (data.model['hasMorePages'] == false) {
            $('.contacts .view-more-btn').addClass('d-none');
          } else {
            $('.contacts .view-more-btn').removeClass('d-none');
          }
        }
      });
  });

  function bindOneCardProduct(item) {
    let template;
    let image;
    if (item.featured_image != null) {
      image = item.featured_image.fullUrl;
    } else {
      image = `${baseUrl}/img/frontend_assets/no-image.jpg`;
    }

    template = `
      <div class="card col-8 col-md-3">
        <header class="pl-card-header">
          <img class="card-img-top" src="${image}"
          alt="Card image cap" data-src="thumbnail">
          <div class="foreground">
            <a href="${item - slug}">
              <i class="fas fa-chevron-right"></i>
            </a>
          </div>
        </header>
        <div class="card-body">
          <h1 class="card-title ft-sz-20" data-src="title">${item.title}</h1>
        </div>
      </div>
    `;

    return template;

  }

  */
})
